import { useTheme } from '@simplywallst/ui-core';
import { formatterPercentage } from '@/utilities/format';

import { VisxText } from '@/components/VisxText';

import type { scaleLinear } from '@visx/scale';

interface Props {
  width: number;
  yScale: ReturnType<typeof scaleLinear<number>>;
}

export const YAxis = ({ yScale, width }: Props) => {
  const theme = useTheme();
  return (
    <g>
      {yScale.ticks(3).map((n) => (
        <g key={`y-axis-${n}`} transform={`translate(0, ${yScale(n)})`}>
          <VisxText
            x={width}
            y={6}
            textAnchor="end"
            verticalAnchor="start"
            opacity={0.3}
            typography="tiny"
            fill={theme.color.white}
          >
            {formatterPercentage(n)}
          </VisxText>
          <rect
            key={`grid-row-${n}`}
            y="0"
            height="1"
            width="100%"
            fill={theme.color.white}
            fillOpacity={yScale(n) === yScale(0) ? 0.3 : 0.1}
          />
        </g>
      ))}
    </g>
  );
};
